const routes = {
  toUrl: (path: string) => `https://love.irish${path}`,

  rootPath: () => "/",
  dashboardPath: () => "/",
  homePath: () => "/home",

  searchPath: () => "/search",
  pricingPath: () => "/pricing",
  signupPath: () => "/signup",
  loginPath: () => "/login",
  logoutPath: () => "/logout",
  settingsPath: () => "/settings",
  settingsProfilePath: () => "/settings/profile",
  settingsCommunityPath: () => "/settings/community",

  aboutUsPath: () => "/about-us",
  communityRulesPath: () => "/community-rules",

  onboardingPath: () => "/start",
  onboardingStepPath: (step: string) => `/start/${step}`,
  onboardingGoalsStepPath: () => routes.onboardingStepPath("goals"),
  onboardingRoleStepPath: () => routes.onboardingStepPath("role"),
  onboardingLevelStepPath: () => routes.onboardingStepPath("level"),
  onboardingAttributionStepPath: () => routes.onboardingStepPath("attribution"),
  onboardingOverviewStepPath: () => routes.onboardingStepPath("overview"),
  onboardingAboutUsStepPath: () => routes.onboardingStepPath("about-us"),
  onboardingCompletedPath: () => routes.onboardingStepPath("your-adventure"),

  blogPostsPath: () => "/blog",
  blogPostPath: (slug: string) => `/blog/${slug}`,

  eventsPath: () => "/events",
  eventPath: (slug: string) => `/events/${slug}`,
  calendarPath: () => `/calendar`,
  calendarEventPath: (slug: string) => `/calendar/${slug}`,
  calendarEventGuestbookPath: (slug: string) => `/calendar/${slug}/guestbook`,
  guestbookPath: () => `/guestbook`,
  faqPath: () => "/faq",
  changelogPath: () => "/changelog",
  collectionsPath: () => "/collections",
  collectionPath: (slug: string) => `/collections/${slug}`,
  newCollectionPath: () => "/collections/new",
  interviewsPath: () => "/interviews",
  interviewPath: (slug: string) => `/interviews/${slug}`,
  libraryPath: () => "/library",
  libraryNewResourcePath: () => "/library/new",
  libraryTypePath: (type: string) => `/library/${type}`,
  libraryResourcePath: (slug: string, type?: string) =>
    type ? `/library/${type}/${slug}` : `/library/${slug}`,
  libraryResourceTabPath: (slug: string, tab: string, type?: string) =>
    type ? `/library/${type}/${slug}/${tab}` : `/library/${slug}/${tab}`,
  libraryResourceDiscussionsPath: (slug: string, type?: string) =>
    routes.libraryResourceTabPath(slug, "discussions", type),
  libraryResourceLyricsPath: (slug: string, type?: string) =>
    routes.libraryResourceTabPath(slug, "lyrics", type),
  pubPath: () => "/pub",
  resourcesPath: () => "/resources",
  resourcePath: (slug: string) => `/resources/${slug}`,
  communityPath: () => "/community",
  adventurePath: () => "/adventure",
  codexPath: () => "/codex",
  codexRecordPath: (slug: string) => `/codex/${slug}`,
  newCodexRecordPath: () => "/codex/new",
  cheatsheetPath: () => "/cheatsheet",
  cheatsheetSectionPath: (key: string) => `/cheatsheet/${key}`,
  shopPath: () => "https://shop.love.irish",
  sitemapPath: () => "/sitemap",
  profilePath: (slug: string) => `/@${slug}`,
  profileCodexPath: (slug: string) => `/@${slug}/codex`,
  profileCollectionsPath: (slug: string) => `/@${slug}/collections`,
  inventoryPath: () => `/inventory`,
  leaderboardPath: () => `/leaderboard`,
  tvPath: () => "/tv",

  // Personal "/my/*" namespace — the owned-by-me hub and its pages.
  myPath: () => "/my",
  myInventoryPath: () => "/my/inventory",
  myCodexPath: () => "/my/codex",
  savedPath: () => "/my/saved",
  myCommunityResourcesPath: () => "/my/community-resources",

  // Stories (root-level for listing and creating)
  storiesPath: () => "/stories",
  newStoryPath: () => "/stories/new",

  // Profile-scoped stories (for show and edit)
  profileStoriesPath: (profileSlug: string) => `/@${profileSlug}/stories`,
  profileStoryPath: (profileSlug: string, storySlug: string) =>
    `/@${profileSlug}/stories/${storySlug}`,
  editProfileStoryPath: (profileSlug: string, storySlug: string) =>
    `/@${profileSlug}/stories/${storySlug}/edit`,

  arcadePath: () => `/arcade`,
  adventureRewardsPath: () => `/adventure/rewards`,
  adventureBannerPath: (slug: string) => `/adventure/rewards/banners/${slug}`,
  adventureBannersPath: () => `/adventure/rewards/banners`,
  adventureAvatarsPath: () => `/adventure/rewards/avatars`,
  adventureChatbotDemo: () => "/adventure/chatbot",
  adventureOghamStonesPath: () => "/adventure/ogham-stones",
  /**
   * Special events
   */
  irishLanguageWeek2023Path: () => routes.eventPath("irish-language-week-2023"),
  irishWeekCalendarPath: () => routes.calendarEventPath("irish-week"),
  stPatricksDayCalendarPath: () => routes.calendarEventPath("st-patricks-day"),
  halloweenCalendarPath: () => routes.calendarEventPath("halloween"),

  wikiPath: () => "/wiki",

  topicsPath: () => "/topics",
  topicPath: (slug: string) => `/topics/${slug}`,
}

export default routes
